export const CHART_TYPES = {
    DESIRED_TEMPERATURE: "DESIRED_TEMPERATURE",
    MEASURED_TEMPERATURE: "MEASURED_TEMPERATURE",
    WINDOW_CONTACT: "WINDOW_CONTACT",
    OFFSET: "OFFSET",
    VALVE_POSITION: "VALVE_POSITION",
    MAX_VALVE_OPENING: "MAX_VALVE_OPENING",
    SF: "SF",
    BATTERY_PERCENTAGE: "BATTERY_PERCENTAGE",
    BATTERY_VOLT: "BATTERY_VOLT",
    SWITCH: "SWITCH",
};

// sorted by priority
export const MONITOR_COLOR_PALETTE = [
    "#5EA43F",
    "#DE176A",
    "#FFAA00",
    "#27A592",
    "#2E86AB",
];
export const DESIRED_TEMPERATURE_COLOR_PALETTE = [
    "#386226",
    "#DE176A",
    "#FFAA00",
    "#27A592",
    "#2E294E",
];
export const MEASURED_TEMPERATURE_COLOR_PALETTE = [
    "#65B045",
    "#EF6BA2",
    "#FFC247",
    "#6ADCCB",
    "#695FAB",
];
export const WINDOW_CONTACT_COLOR_PALETTE = [
    "#2E294E",
    "#27A592",
    "#FFAA00",
    "#DE176A",
    "#386226",
];
export const VALVE_COLOR_PALETTE = [
    "#386226",
    "#DE176A",
    "#FFAA00",
    "#27A592",
    "#2E294E",
];

export const SWITCH_COLOR_PALETTE = [
    "#D94D1A",
    "#3A86FF",
    "#FF6D00",
    "#7D3C98",
    "#00B159",
];

export const SPREADING_FACTOR_COLOR_PALETTE = [
    "#0E9594", // teal
    "#2C699A", // steel blue
    "#6A4C93", // deep purple
    "#8AC926", // lime green
    "#FF595E", // coral red
];

export const BATTERY_PERCENT_COLOR_PALETTE = [
    "#F3722C", // orange
    "#577590", // blue-gray
    "#43AA8B", // green
    "#FFCA3A", // sunflower
    "#F94144", // red
];

export const BATTERY_VOLT_COLOR_PALETTE = [
    "#3D348B", // indigo
    "#F18701", // amber
    "#2E4057", // slate
    "#9E0059", // magenta
    "#00A896", // aqua
];

const DEFAULT_CHART_COLOR = "#5EA43F";
export const PRIMARY_DEFAULT_DARK_COLOR = "#2A2631";

export const ACTIVITIES_COLOR = DEFAULT_CHART_COLOR;
